module.exports = __webpack_public_path__ + "img/freelance1.1c395317.png";